import React from 'react';
import { Radio } from '@mui/material';

const RadioButton = ({ value, onChange, disabled = false, ...rest }) => {
  const _handleChange = (e) => onChange(e.target.checked);

  return (
    <Radio
      checked={!!value}
      onChange={_handleChange}
      value={value}
      disabled={disabled}
      data-testid={`input-${rest?.name || 'radio-button'}`}
      sx={rest?.styles}
      {...rest}
    />
  );
};

export default RadioButton;
